<template>
  <div class="nx-report-header">
    <div class="nx-report-header__left">
      <div v-if="crumb" class="nx-crumb">{{ crumb }}</div>
      <h2 class="nx-page-title">{{ title }}</h2>
      <div v-if="subtitle" class="nx-report-header__subtitle">{{ subtitle }}</div>
    </div>
    <div class="nx-report-header__right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NxReportHeader',
  props: {
    crumb: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.nx-report-header__left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nx-report-header__subtitle {
  font-size: 14px;
  color: #6B7280;
}

.nx-report-header__right {
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>

